import React from "react";

const MakesusDiff = () => {
  return (
    <div className="w-full bg-[#FFFFFF]">
      <div className="relative max-w-[80%] max-xxxl:max-w-[90%] mx-auto mt-[50px] pb-[40px] mb-[80px] flex flex-col items-center gap-[20px]">
        {/* Heading */}
        <h2 className="text-center text-[36px] md:text-[40px] lg:text-[48px] text-[#1A202C] font-sora font-semibold tracking-[-1px] leading-[50px] md:leading-[60px]">
          What Makes Us <span className="words">Different</span>?
        </h2>

        {/* Cards Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] border mt-[20px] bg-[#FFFFFF] border-gray-300 shadow-[0px_0px_10.9px_0px_rgba(0,_4,_47,_0.15)] rounded-[20px] py-[27px] px-[88px] md:px-[40px] lg:px-[88px]">
          {/* Card 1 */}
          <div className="flex flex-col items-center text-center  p-[20px]  ">
            <img
              src="../../assets/icons/trust.svg"
              alt="Icon 1"
              className="w-[60px] h-[60px] mb-[20px]"
            />
            <h3 className="text-[#1A202C] font-sora text-[20px] font-semibold mb-[10px]">
              Your Needs & Trust
            </h3>
            <p className="text-[#718096] font-manrope text-[16px]">
              We tailor to your needs, NOT to what we think a law firm needs.
            </p>
          </div>

          {/* Card 2 */}
          <div className="flex flex-col items-center text-center  p-[20px]  ">
            <img
              src="../../assets/icons/globe.svg"
              alt="Icon 2"
              className="w-[60px] h-[60px] mb-[20px]"
            />
            <h3 className="text-[#1A202C] font-sora text-[20px] font-semibold mb-[10px]">
              Your Needs & Trust
            </h3>
            <p className="text-[#718096] font-manrope text-[16px]">
              We allow you to grow globally. We take care of your international
              clients for smoother communication and interaction.
            </p>
          </div>

          {/* Card 3 */}
          <div className="flex flex-col items-center text-center  p-[20px]  ">
            <img
              src="../../assets/icons/connection.svg"
              alt="Icon 3"
              className="w-[60px] h-[60px] mb-[20px]"
            />
            <h3 className="text-[#1A202C] font-sora text-[20px] font-semibold mb-[10px]">
              Your Needs & Trust
            </h3>
            <p className="text-[#718096] font-manrope text-[16px]">
              We educate your staff to integrate Kameleon.Law to suit their
              preference of working. We do NOT want to replace them with AI.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MakesusDiff;
